export const help = {
	selector: {
		form: '.js-editor-help',
		checkbox: 'input[name="enable"]',
		inputs: 'div.input-field',
		translationInput: '[name="translation"]',
	},
}
